import { __ } from '@wordpress/i18n';
import { useMemo } from '@wordpress/element';
import { parse } from '@wordpress/blocks';
import { BlockPreview } from '@wordpress/block-editor';
import { MdFavoriteBorder, MdOutlineFavorite } from 'react-icons/md';

const KitCard = ({ title, pattern, isFavorite, onToggleFavorite, templateCount, onClick ,style, premium,isProActive,handleUpgradeClick}) => {
	const isProAvailable = typeof isProActive === 'boolean';
	const isPremium = premium?.toLowerCase() === 'pro' && isProAvailable && isProActive === false;

	const previewBlocks = useMemo(() => {
		try {
			return pattern ? parse(pattern) : [];
		} catch (e) {
			console.error('Pattern parsing failed:', e);
			return [];
		}
	}, [pattern]);

	return (
		<div className="vayu-template-card vayu-kit-card" style={style}>
			<div className="vayu-template-preview" onClick={onClick}>
				{previewBlocks.length > 0 ? (
					<BlockPreview blocks={previewBlocks} __experimentalLayout={{ type: 'default' }} />
				) : (
					<div className="vayu-preview-loader">Loading preview…</div>
				)}
			</div>

			<div className="vayu-template-card-footer">
				<div className="vayu-template-card-title-group">
					<div className="vayu-template-card-title">{title} {isPremium && (
						<span className="vayu-pro-badge" onClick={handleUpgradeClick} title="Pro Template">
							PRO
						</span>
					)}</div>
					<div className="vayu-kit-template-count">
						{templateCount} {__('Templates Included', 'vayu-blocks')}
					</div>
				</div>

				<button
					type="button"
					className={`vayu-template-card-fav-btn ${isFavorite ? 'is-favorited' : ''}`}
					onClick={(e) => {
						e.stopPropagation();
						console.log(e);
						onToggleFavorite();
					}}
					aria-label={
						isFavorite
							? __('Remove from favorites', 'vayu-blocks')
							: __('Add to favorites', 'vayu-blocks')
					}
				>
					{isFavorite ? <MdOutlineFavorite size={20} /> : <MdFavoriteBorder size={20} />}
				</button>
			</div>

			<button className="vb-kit-inset-button" onClick={onClick}>
				{__('View Templates', 'vayu-blocks')}
			</button>
		</div>
	);
};

export default KitCard;
